export const ProviderProfileSubSectionIds = {
  PROVIDER_PROFILE_AT_A_GLANCE_SECTION: "provider-profile-at-a-glance-section",
  PROVIDER_PROFILE_AVAILABILITY_SECTION:
    "provider-profile-availability-section",
  PROVIDER_PROFILE_LOCATIONS_SECTION: "provider-profile-locations-section",
  PROVIDER_PROFILE_SPECIALITIES_SECTION:
    "provider-profile-specialities-section",
  PROVIDER_PROFILE_QUALIFICATIONS_SECTION:
    "provider-profile-qualifications-section",
  PROVIDER_PROFILE_CLIENT_FOCUS_SECTION:
    "provider-profile-client-focus-section",
  PROVIDER_PROFILE_TREATMENT_APPROACH_SECTION:
    "provider-profile-treatment-approach-section",
  PROVIDER_PROFILE_INSURANCE_SECTION: "provider-profile-insurance-section",
}

export const PracticeProfileSubSectionIds = {
  PRACTICE_PROFILE_AT_A_GLANCE_SECTION: "practice-profile-at-a-glance-section",
  PRACTICE_PROFILE_LOCATION_SECTION: "practice-profile-location-section",
  PRACTICE_PROFILE_NEW_PATIENT_STATUS_SECTION:
    "practice-profile-new-patient-status-section",
  PRACTICE_PROFILE_PROVIDED_CARE_SECTION:
    "practice-profile-provided-care-section",
  PRACTICE_PROFILE_LOCATION_MAP_SECTION:
    "practice-profile-location-map-section",
  PRACTICE_PROFILE_SPECIALITIES_SECTION:
    "practice-profile-specialities-section",
  PRACTICE_PROFILE_CLIENT_FOCUS_SECTION:
    "practice-profile-client-focus-section",
  PRACTICE_PROFILE_TREATMENT_APPROACH_SECTION:
    "practice-profile-treatment-approach-section",
  PRACTICE_PROFILE_INSURANCE_SECTION: "practice-profile-insurance-section",
  PRACTICE_PROFILE_THERAPIST_SECTION: "practice-profile-therapist-section",
}
